import {Action, configureStore, PreloadedState, ThunkAction} from '@reduxjs/toolkit';
import {FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from "./Reducers/RootReducer";

let reduxLoggerMiddleware: any = undefined;
if (process.env.NODE_ENV === 'development' || (typeof window !== 'undefined' && window.location.hostname.includes('dev.sgd.energy'))) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { createLogger } = require('redux-logger');
    reduxLoggerMiddleware = createLogger({
        collapsed: true,
        duration: true,
        diff: false,
        timestamp: true,
    });
}

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
};
let persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//     reducer: persistedReducer,
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware(
//         {
//             serializableCheck: {
//                 ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//                 // Ignore these field paths in all actions
//                 ignoredActionPaths: ['payload.config', 'payload.request', 'error', 'meta.arg'],
//             }
//         }),
//         // .concat(logger),
//     devTools: process.env.NODE_ENV !== 'production',
//     }
// );

export function setupStore(preloadedState?: PreloadedState<RootState>) {
    return configureStore({
        reducer: persistedReducer,
       middleware: (getDefaultMiddleware) => {
            const base = getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                    ignoredActionPaths: ['payload.config', 'payload.request', 'error', 'meta.arg'],
                }
            });

            // adiciona logger somente se definido
            if (reduxLoggerMiddleware) {
                return base.concat(reduxLoggerMiddleware);
            }
            return base;
        },
        devTools: process.env.NODE_ENV !== 'production',
        preloadedState
    })
}

export const store : AppStore = setupStore();
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof persistedReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,RootState,unknown,Action<string>>;
